/* global femcare */
/* eslint-disable id-length */

femcare.shared.util = {
    baseUrl: $('body').attr('data-base-url'),
    $modal: $('#modal'),

    mediaqueries: {
        extraSmall: 1,
        small: 2,
        medium: 3,
        large: 4,
        largeNav: 5,
        extraLarge: 6  
    },

    // $screen-lg-navbar
    richNavbarScreenMinWidth: 1280,

    getAssetsPath: function () {
        return $('[data-static-directory]').data('static-directory') || '';
    },


    getMediaqueryState: function() {
        var indicatorEl = document.querySelector('.mediaquery-state-indicator');
        var mediaqueryIndicator = window.getComputedStyle(indicatorEl, ':before').getPropertyValue('content');

        return parseInt(mediaqueryIndicator.replace(/^"(.*)"$/, '$1'), 10);
    },

    // Check if browser or screen width satisfies rich navbar threshold.
    isRichNavbarActive: function() {
        return (
            window.innerWidth >= this.richNavbarScreenMinWidth ||
            screen.width >= this.richNavbarScreenMinWidth
        );
    },

    // Durstenfeld algorithm for array shuffle
    shuffleArray: function(array) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
    },

    // Checks if DOM element is within viewport
    // https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
    isElementInViewport: function(el) {
        if (typeof jQuery === 'function' && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight ||
                    document.documentElement.clientHeight) /* or $(window).height() */ &&
            rect.right <=
                (window.innerWidth ||
                    document.documentElement.clientWidth) /* or $(window).width() */
        );
    },

    // Verifies that right-to-left layout is active
    isRTLContext: function () {
        return $('body').hasClass('rtl');
    },

    // Get frontend assets path
    getAssetsPath: function () {
        var assetsPath = $('[data-static-directory]').data('static-directory') || '';
        if (assetsPath.substring(assetsPath.length - 1) === '/') {
            assetsPath = assetsPath.substring(0, assetsPath.length - 1);
        }

        return assetsPath;
    }
};
